import permisos from "./permisos"

const isPermisoValid = (rol_id,modulo_id) => permisos.permisos.find( x => x.rol_id == rol_id ).modulos.some( x => x.modulo_id == modulo_id && x.permiso == true )

const isPermisoAccionValid = function(rol_id,accion_id){
    return permisos.permisos.find( x => x.rol_id == rol_id ).acciones.some( x => x.accion_id == accion_id && x.permiso == true )
}
export {isPermisoValid,isPermisoAccionValid}